import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/styles.css'
import './styles/video-protection.css'
import Toast from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { APP_NAME } from './config/app'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Toast, {
  autoClose: 3000,
  position: 'top-right'
})

// Set dynamic page title
document.title = `${APP_NAME} Management System`

app.mount('#app')